import { api } from './index';

const BASE_PATH = '/api/internal/representatives';

export type Representative = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  dni: string;
  fullName: string;
  observations: string;
  passwordIsSet: boolean;
  usesApp: boolean;
}

export interface RepresentativeForm {
  id: number | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  phoneNumber: string | undefined;
  dni: string | undefined;
  _destroy: boolean;
  notAssociatedYet: boolean;
  isEditing: boolean;
  observations?: string | undefined;
  // Read-only, from the server: whether the representative already created a Kuido Familia password.
  passwordIsSet?: boolean;
  // Read-only, from the server: whether the representative already signed in to Kuido Familia by any method.
  usesApp?: boolean;
  // Mail the "Crear contraseña" link after saving the patient (ignored when a password exists).
  sendAppAccess?: boolean;
  // Receives the billing emails (charges email and DTE) for this patient. While nobody is
  // ticked, the first representative receives them.
  receivesCharges?: boolean;
}

export const representativesApi = {
  index(): Promise<Array<Representative>> {
    return api({
      method: 'get',
      url: BASE_PATH,
    }).then(response => response.data.representatives);
  },
};
